/**
 * @desc 修改成交公告
 */
import {
  AnnouncementEntity,
  TransactionAnnouncementForm
} from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type UpdateTransactionAnnouncementParameter = TransactionAnnouncementForm

const method = 'PUT'
const url = '/trade/operation/announcement/transaction'

export const updateTransactionAnnouncementApi = (
  data?: UpdateTransactionAnnouncementParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<AnnouncementEntity>({
    method,
    url,
    data,
    ...config
  })
}

updateTransactionAnnouncementApi.method = method
updateTransactionAnnouncementApi.url = url
